var _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 14,
    viewBox: "0 0 29 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1726_474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 21,
    height: 11
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.08975,
    y: 3.46997,
    width: 20.8205,
    height: 10.4103,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1726_474)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.79698,
    y: 0.55,
    width: 17.4071,
    height: 12.7803,
    rx: 1.45,
    stroke: "#001533",
    strokeWidth: 1.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51329 0.6H14.5H22.4867C23.8662 0.6 24.4142 2.38455 23.2724 3.15874L15.2857 8.57423C14.8113 8.89591 14.1887 8.89591 13.7143 8.57423L5.72759 3.15874C4.58582 2.38455 5.13379 0.6 6.51329 0.6Z",
    stroke: "#888888",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMail);
export default __webpack_public_path__ + "static/media/menu_mail.395752782269244b0b81c4ff30b4682f.svg";
export { ForwardRef as ReactComponent };